import React from 'react';

import { TemplateMarkdown, TemplateNames } from '../../../../client/templates/templates';
import { StoredNotification } from '../../../model/StoredNotification';
import { NotificationOptions } from '../../../../client/';

import { TemplateCustomComponent } from './TemplateCustomComponent/TemplateCustomComponent';
import { TemplateMarkdownComponent } from './TemplateMarkdownComponent/TemplateMarkdownComponent';
import { TemplateListComponent } from './TemplateListComponent/TemplateListComponent';
import { GetTemplateName } from '../../../model/templates/isTemplate';

export interface TemplateComponentProps<T extends NotificationOptions = NotificationOptions> {
  notification: StoredNotification<T>;
}

export type TemplateComponent<T extends NotificationOptions = NotificationOptions> = React.FC<
  TemplateComponentProps<T>
>;

type ComponentMapType = Omit<
  {
    [K in GetTemplateName<NotificationOptions['template']>]: TemplateComponent<
      Extract<NotificationOptions, { template: K }>
    >;
  },
  'markdown'
> & { markdown: TemplateComponent<TemplateMarkdown> };

export const TemplateComponentMap: ComponentMapType = {
  [TemplateNames.markdown]: TemplateMarkdownComponent,
  [TemplateNames.list]: TemplateListComponent,
  [TemplateNames.custom]: TemplateCustomComponent,
};
